<template>
    <div>        
        <div class="cont-box" :style="{backgroundImage:'url('+bg+')'}"> 
            <img class="back" src="@/assets/icon_back.png" alt="back" @click="goBack">
            <div class="logo-box">
                <img class="logo" src="@/assets/logo.png" alt="">
                <div>{{this.$t('download.app')}}</div>
            </div>           
            <a class="btn-box btn-and" :href="downLoad.android_url">
				<img class="icon" src="@/assets/andriod.png" alt="android"> 
				<div>Android {{this.$t('download.xz')}}</div>
			</a>
            <a class="btn-box btn-and" :href="downLoad.ios_url">
				<img class="icon" src="@/assets/ios.png" alt="IOS"> 
				<div>IOS {{this.$t('download.xz')}}({{this.$t('download.qm')}})</div>
			</a>
            <a class="btn-box" :href="downLoad.ios1_url">
				<img class="icon" src="@/assets/ios.png" alt="IOS"> 
				<div>IOS {{this.$t('download.xz')}}({{this.$t('download.cjqm')}})</div>
			</a>
        </div>  
    </div>
</template>
<script>
export default {
    name: 'downLoad',
    data () {
        return {      
           downLoad: '',
           lang: 'en',
           bg: require('@/assets/down.jpg')
        }
    },  
    created(){      
        this.lang = localStorage.getItem('user_lang');       
    },
    mounted(){
        this.getDownLoad();
        if(this.lang == 'en'){
            this.bg = require('@/assets/down.jpg')
        }else{
            this.bg = require('@/assets/down-zh.jpg')
        }
    },  
    methods: {
        getDownLoad(){//下载链接         
            this.$ajax.post('/api/index/getClient').then((res) => {                
                let resData = res.data.data;                
                if(res.data.code == 200){
                    this.downLoad = resData;
                }else{
                    this.$toast.bottom(res.data.msg);                    
                }
            }).catch(function(err){
                console.log(err)
            })
        },
        goBack(){
            this.$router.go(-1);
        }
    }    
}
</script>
<style scoped>
    .cont-box{
        position: absolute;
        top: 0;
        bottom: 0;        
        width: 100%; 
        height: auto;
        padding-top: 1rem;
        background-size: cover;
    } 
    .cont-box .bg-img{
        width: 100%;
        height: 100%;
    }
    .back{
        position: absolute;
        left: .3rem;
        top: .2rem;
        width: .24rem;
        height: .44rem;
    }
    .logo-box{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .36rem;
        font-weight: bold;
    }
    .logo-box .logo{
        width: 1rem;
        /* height: 1rem; */
        margin-right: .2rem;
    }
    .btn-box{       
        display: flex;
        justify-content: center;
        align-items: center;
        width: 80%;
        height: 1rem;
        margin-left: 10%;
        color: #fff;
        font-size: .3rem;
        background: rgba(255,255,255,.2);
        border-radius: 16px;
    }
    .btn-and{
        margin: .6rem 10%;
    }
    .btn-box .icon{
        width: .48rem;
        /* height: .56rem; */
        margin-right: .12rem;
    }    
</style>


// WEBPACK FOOTER //
// src/pages/downLoad.vue